module.exports = __webpack_public_path__ + "static/media/appstore.38420abc.png";